export default [
  '#920505',
  '#EE6237',
  '#CDB83D',
  '#5DCD3E',
  '#052992',
]
